import { ThemeSchemaResponse } from '@api/api/theme-overview';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useQueries } from '@tanstack/react-query';
import { fetchTheme } from '@terminal/services/overview-widget/overview-widget-service';

import { QUERY_KEY_THEME_DETAILS_V2 } from './useThemeDetails';

export const useThemesDetails = ({
  themeIds,
  enabled = true,
}: {
  themeIds: string[];
  enabled?: boolean;
}) => {
  const queries = [...new Set(themeIds)].map(themeId => ({
    queryKey: [QUERY_KEY_THEME_DETAILS_V2, themeId.trim()],
    queryFn: ({ signal }: { signal?: AbortSignal }) =>
      fetchTheme({ themeId: themeId.trim(), signal }),
    staleTime: getTimeTillEndOfDayMs(),
    enabled: enabled && themeId.trim().length > 0,
  }));

  return useQueries({
    queries,
    combine: results => ({
      data: results
        .map(r => r.data)
        .filter((d): d is ThemeSchemaResponse => d !== undefined),
      isLoading: results.some(r => r.isLoading),
      isError: results.length > 0 && results.every(r => !!r.error),
    }),
  });
};
